import React from "react";
import { useAppSettings, useTheme } from "@springbig/shared";
import { Skeleton } from "native-base";
import { ISkeletonTextProps } from "native-base/lib/typescript/components/composites";

export const DarkSkeleton = ({ ...props } : ISkeletonTextProps) => {

    const {
        radius_sm,
    } = useTheme();

    const {
        skeleton_start_color, 
        skeleton_end_color
    } = useAppSettings();
    
    const rounded = radius_sm ?? "md";
    
    return <Skeleton rounded={rounded} startColor={skeleton_start_color} endColor={skeleton_end_color} {...props} />;
};